import { ReactComponent as IconAdd } from "assets/svg/add.svg";
import DashboardsListing from "components/cards/dashboards-listing";
import { useHistory, useLocation } from "react-router-dom";

export interface IDashboardsTabProps {
  clientId: string;
}

export default function DashboardsTab(props: IDashboardsTabProps) {
  let history = useHistory();
  let location = useLocation();
  let newDashboardLink = location.pathname + "/new";

  return (
    <div className="c-tabs-item is-active" id="tabsUsers">
      <div className="u-mb-spacer-base-large">
        <div className="c-page-title">
          <h6>Dashboards</h6>
          <div
            onClick={() => {
              history.push(newDashboardLink);
            }}
            className="c-button c-button--stroke c-button--secondary c-button--icon u-hidden@md"
          >
            <IconAdd className="o-svg-icon" />
          </div>
          <div
            onClick={() => {
              history.push(newDashboardLink);
            }}
            className="c-button c-button--stroke c-button--secondary u-hidden u-block@md"
          >
            <IconAdd className="o-svg-icon" />
            <span>Add new Dashboard</span>
          </div>
        </div>
        <DashboardsListing clientId={props.clientId} />
      </div>
    </div>
  );
}
